import React from "react";

const TextBlock = ({ block, className }) => {
  return (
    <div className="text-block__container w-100">
      {block.headline && (
        <h2 className="text-block__headline pb1 pb2-l h-2--small h-2--l dark ">
          {block.headline}
        </h2>
      )}
      {block.subheadline && (
        <h3 className="text-block__subheadline p-emphasis h-3--l ttu dark">
          {block.subheadline}
        </h3>
      )}
      <div
        className={`${className} text-block__body p mb0 grey2`}
        dangerouslySetInnerHTML={{ __html: block.content }}
      />
    </div>
  );
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/TextBlock.js